<template>
  <b-card
    :img-src="eventImage"
    img-width="410"
    img-left
    img-height="236"
    class="shadow-large"
  >
    <b-card-text class="mb-0">
      <div
        class="border-bottom pb-2"
      >
        <strong>{{ event.title }}</strong>
      </div>

      <h6 class="text-warning my-2">
        {{ $moment(event.start_date).format('dddd, MMMM DD, YYYY h:mm A z') }}
      </h6>

      <div class="mb-2">
        <feather-icon
          icon="DollarSignIcon"
          class="mr-50 text-primary"
          size="20"
        />
        <strong v-if="!event.powered_by_muslimdo">
          {{ event.scrapped_event_price }}
        </strong>
        <strong
          v-else-if="event.max_tickets_price"
          class="d-inline-block mr-2"
        >{{ event.min_tickets_price + '$' || 'Free' }} - {{ event.max_tickets_price }}$</strong>
        <strong
          v-else
          class="mr-2"
        >Free</strong>

        <template
          v-if="event.powered_by_muslimdo"
        >
          <feather-icon
            icon="UsersIcon"
            class="mr-50 ml-3 text-primary"
            size="20"
          />
          <strong>Capacity: {{ event.sold_tickets.split(' / ')[1] }}</strong>
        </template>
      </div>

    </b-card-text>
    <div class="text-right mt-4">
      <span class="interaction">
        <feather-icon
          icon="Share2Icon"
          size="20"
          @click="copyURL"
        />
      </span>
      <span class="interaction">
        <feather-icon
          icon="HeartIcon"
          size="20"
          fill="none"
          @click="likeEvent($event)"
        />
      </span>
    </div>
  </b-card>
</template>

<script>
import handleAlerts from '@/compositions/common/handleAlerts'
import Users from '@/compositions/TeamManagement/Users/UsersAPI'

export default {
  name: 'EventPreview',
  props: {
    event: { type: Object, default: () => ({}) },
  },
  computed: {
    eventImage() {
      return this.event.main_image?.url
    },
  },
  setup() {
    const { toggleEventLike } = Users()
    const { successfulOperationAlert } = handleAlerts()
    return { toggleEventLike, successfulOperationAlert }
  },
  methods: {
    likeEvent($event) {
      this.toggleEventLike(this.event.id).then(res => {
        const color = res.data.data.isLiked ? '#f00' : 'none'
        $event.target.setAttribute('fill', color)
      })
    },
    copyURL() {
      navigator.clipboard.writeText(this.event.url).then(() => {
        this.successfulOperationAlert(`${this.event.title} Event URL is copied successfully`)
      })
    },
  },
}
</script>

<style scoped>
.interaction{
  margin-right: 7px;
  padding: 6px;
  border:1px solid #000;
  border-radius: 50%;
  cursor: pointer;
}
.card-event {
  box-shadow: 0px 4px 15px 0px #0000001A;
  border-radius: 15px;
  padding: 22.5px 20px;
  background: #FFFFFF;
  margin-bottom: 30px;
}

.card-event-list div:first-child img {
  width: 132px;
  height: 100px;
  border-radius: 10px;
  margin-right: 10px;
  object-fit: cover;
}

.card-event-list div .event-info {
  font-size: 1.125rem;
  line-height: 1.167rem;
  color: #141522;
  margin-bottom: 2.5px;
  font-family: 'Nunito-Bold';
}

.card-event-list div .event-info span {
  background: rgba(237, 121, 35, 0.06);
  padding: 2.5px 16px 4.5px 16px;
  font-size: 0.75rem;
  color: #ED7923;
  border-radius: 40px;
  font-family: 'Outfit-Regular';
}

.card-event-list div .text-date {
  font-size: 0.875rem;
  color: #828181;
  line-height: 1.31rem;
  margin-bottom: 6px;
  font-family: 'Nunito-SemiBold';
}

.card-event-list div .text-location {
  font-size: 0.875rem;
  line-height: 1.31rem;
  color: #313131;
  margin-bottom: 6px;
  font-family: 'Nunito-Regular';
}

.card-event-list div .event-time {
  color: #313131;
  font-size: 0.875rem;
  line-height: 1.31rem;
  font-family: 'Nunito-Regular';
}

.card-event-list div .event-time span {
  color: #197687;
}

.card .shadow-large {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47,0.1) !important;
}
</style>
